export enum PageSwitcherTypes {
  Browse = 'BROWSE',
  Product = 'PRODUCT',
  External = 'EXTERNAL',
  Bypass = 'BYPASS',
}
